import { OrganizationalUnit } from '../models/org-units/orgUnit';
import { OrgUnitUser } from '../models/org-units/orgUnitUser';
import ApiService from './apiService';

class OrgUnitsService extends ApiService {
  private static instance?: OrgUnitsService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!OrgUnitsService.instance) {
      OrgUnitsService.instance = new OrgUnitsService();
    }
    return OrgUnitsService.instance;
  }

  getAll(): Promise<OrganizationalUnit[]> {
    return this.client.get(`/org-units`).then((response) => {
      return response.data;
    });
  }

  getHierarchy(): Promise<OrganizationalUnit[]> {
    return this.client.get(`/org-units/hierarchy`).then((response) => {
      return response.data;
    });
  }

  getById(id: string): Promise<OrganizationalUnit> {
    return this.client.get(`/org-units/${id}`).then((response) => {
      return response.data;
    });
  }

  create(orgUnit: OrganizationalUnit): Promise<OrganizationalUnit> {
    return this.client.post(`/org-units`, orgUnit).then((response) => {
      return response.data;
    });
  }

  update(orgUnit: OrganizationalUnit): Promise<OrganizationalUnit> {
    return this.client.put(`/org-units/${orgUnit.orgUnitId}`, orgUnit).then((response) => {
      return response.data;
    });
  }

  delete(id: string): Promise<void> {
    return this.client.delete(`/org-units/${id}`).then(() => {
      return;
    });
  }

  getUsersByOrgUnitId(id: string): Promise<OrgUnitUser[]> {
    return this.client.get(`/org-units/${id}/users`).then((response) => {
      return response.data;
    });
  }

  // User management methods
  getUsers(orgUnitId: string): Promise<OrgUnitUser[]> {
    return this.client.get(`/org-units/${orgUnitId}/users`).then((response) => {
      return response.data;
    });
  }

  getUser(orgUnitId: string, userId: string): Promise<OrgUnitUser> {
    return this.client.get(`/org-units/${orgUnitId}/users/${userId}`).then((response) => {
      return response.data;
    });
  }

  addUser(orgUnitId: string, userId: string): Promise<OrgUnitUser> {
    return this.client.put(`/org-units/${orgUnitId}/users/${userId}`).then((response) => {
      return response.data;
    });
  }

  updateUser(orgUnitId: string, userId: string, user: OrgUnitUser): Promise<OrgUnitUser> {
    return this.client.put(`/org-units/${orgUnitId}/users/${userId}`, user).then((response) => {
      return response.data;
    });
  }

  removeUser(orgUnitId: string, userId: string): Promise<void> {
    return this.client.delete(`/org-units/${orgUnitId}/users/${userId}`).then(() => {
      return;
    });
  }
}

export default OrgUnitsService;
